import React from 'react';

interface Icon3DUITrainingProps {
  size?: string;
}

const Icon3DUITraining: React.FC<Icon3DUITrainingProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'ui-tilt 3s ease-in-out infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" className="w-full h-full" style={{ filter: 'drop-shadow(0 2px 8px rgba(236, 72, 153, 0.3))' }}>
          <defs>
            <linearGradient id="uitrainingGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#ec4899" />
              <stop offset="50%" stopColor="#f472b6" />
              <stop offset="100%" stopColor="#db2777" />
            </linearGradient>
          </defs>
          <rect x="2" y="3" width="20" height="16" rx="1.5" fill="url(#uitrainingGradient)" opacity="0.15" stroke="url(#uitrainingGradient)" strokeWidth="1.5" />
          <circle cx="7" cy="8" r="1.5" fill="url(#uitrainingGradient)" opacity="0.6" />
          <circle cx="12" cy="8" r="1.5" fill="url(#uitrainingGradient)" opacity="0.6" />
          <circle cx="17" cy="8" r="1.5" fill="url(#uitrainingGradient)" opacity="0.6" />
          <rect x="4" y="11" width="4" height="6" rx="0.5" fill="url(#uitrainingGradient)" opacity="0.4" />
          <rect x="10" y="11" width="4" height="6" rx="0.5" fill="url(#uitrainingGradient)" opacity="0.4" />
          <rect x="16" y="11" width="2" height="6" rx="0.5" fill="url(#uitrainingGradient)" opacity="0.4" />
        </svg>
        <style>{`
          @keyframes ui-tilt {
            0%, 100% { transform: rotateX(0deg) rotateY(0deg); }
            50% { transform: rotateX(8deg) rotateY(-12deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DUITraining;
